var _g, _rect, _rect2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBenefitCardGreen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 210,
    height: 107,
    viewBox: "0 0 210 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_571_9506)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 209.6,
    height: 107,
    rx: 16,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.617 23.2404C99.258 1.83447 106.254 -25.3418 127.242 -37.4595C148.231 -49.5772 175.264 -42.0476 187.623 -20.6416C199.981 0.764266 192.986 27.9405 171.997 40.0582C151.009 52.1759 123.975 44.6463 111.617 23.2404ZM169.192 -10.0008C162.827 -21.0253 148.904 -24.9032 138.095 -18.6623C127.285 -12.4214 123.682 1.57495 130.047 12.5995C136.412 23.624 150.335 27.5019 161.145 21.261C171.954 15.0202 175.557 1.02378 169.192 -10.0008Z",
    fill: "#A7CE6A",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.341 73.6482C240.724 67.6523 235.731 62.5689 229.772 58.8168C223.813 55.0647 217.059 52.7512 210.065 52.0668C203.072 51.3825 196.039 52.3468 189.547 54.8805C183.056 57.4142 177.29 61.4448 172.725 66.6401C168.16 71.8354 164.927 78.047 163.292 84.763C161.657 91.4791 161.666 98.5075 163.32 105.269C164.973 112.031 168.223 118.333 172.803 123.656C177.382 128.979 183.159 133.17 189.658 135.885L197.764 116.355C194.417 114.957 191.442 112.799 189.084 110.057C186.725 107.316 185.051 104.07 184.2 100.588C183.348 97.1053 183.343 93.4855 184.185 90.0266C185.028 86.5676 186.693 83.3686 189.044 80.6928C191.395 78.0171 194.364 75.9413 197.708 74.6364C201.051 73.3315 204.673 72.8348 208.275 73.1873C211.877 73.5397 215.355 74.7312 218.424 76.6637C221.493 78.5961 224.065 81.2142 225.927 84.3022L244.341 73.6482Z",
    fill: "#A7CE6A",
    fillOpacity: 0.16
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 208.6,
    height: 106,
    rx: 15.5,
    stroke: "url(#paint0_linear_571_9506)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 208.6,
    height: 106,
    rx: 15.5,
    stroke: "#EAF3DB"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_571_9506",
    x1: 8.70209,
    y1: 5.40019,
    x2: 198.867,
    y2: 114.498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_571_9506"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 209.6,
    height: 107,
    rx: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenefitCardGreen);
export default __webpack_public_path__ + "static/media/benefitCardGreen.06d77d755e5577310c88e538e015f9c8.svg";
export { ForwardRef as ReactComponent };